import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   meta: {
  //     title: '首页',
  //     noShowTitle: false,
  //     // keepAlive: true,
  //   },
  //   component: () => import('./views/home'),
  // },
  {
    path: '/',
    name: 'home',
    meta: {
      title: '公司介绍',
      iftoTop: true,
    },
    component: () => import('./views/aboutus/aboutus'),
  },
  {
    path: '/textbook',
    name: 'textbook',
    meta: {
      title: '教材',
      iftoTop: true,
    },
    component: () => import('./views/textbook/textbook'),
  },
  {
    path: '/textbookDetails',
    name: 'textbookDetails',
    meta: {
      title: '教材详情',
      iftoTop: true,
    },
    component: () => import('./views/textbook/textbookDetails'),
  },
  {
    path: '/product',
    name: 'product',
    meta: {
      title: '产品',
      iftoTop: true,
    },
    component: () => import('./views/product/index'),
  },
  {
    path: '/product/student',
    name: 'student',
    meta: {
      title: '我是学生',
      iftoTop: true,
    },
    component: () => import('./views/product/student'),
  },
  {
    path: '/product/teacher',
    name: 'teacher',
    meta: {
      title: '我是老师',
      iftoTop: true,
    },
    component: () => import('./views/product/teacher'),
  },
  {
    path: '/product/schoolmaster',
    name: 'schoolmaster',
    meta: {
      title: '我是校长',
      iftoTop: true,
    },
    component: () => import('./views/product/schoolmaster'),
  },
  {
    path: '/product/parent',
    name: 'parent',
    meta: {
      title: '我是家长',
      iftoTop: true,
    },
    component: () => import('./views/product/parent'),
  },
  {
    path: '/product/doubleteacher',
    name: 'doubleteacher',
    meta: {
      title: '双师课堂',
      iftoTop: true,
    },
    component: () => import('./views/product/doubleteacher'),
  },
  {
    path: '/service',
    name: 'service',
    meta: {
      title: '服务',
      iftoTop: true,
    },
    component: () => import('./views/service/index'),
  },
  {
    path: '/service/ced',
    name: 'ced',
    meta: {
      title: '定制化企业诊断',
      iftoTop: true,
    },
    component: () => import('./views/service/ced'),
  },
  {
    path: '/service/3s',
    name: '3s',
    meta: {
      title: '3S教学',
      iftoTop: true,
    },
    component: () => import('./views/service/3sTeaching'),
  },
  {
    path: '/service/teaTrain',
    name: 'teaTrain',
    meta: {
      title: '教师培训',
      iftoTop: true,
    },
    component: () => import('./views/service/teaTrain'),
  },
  {
    path: '/service/operation',
    name: 'operation',
    meta: {
      title: '运营管理',
      iftoTop: true,
    },
    component: () => import('./views/service/operation'),
  },
  {
    path: '/joinCooperation',
    name: 'joinCooperation',
    meta: {
      title: '合作加盟',
      iftoTop: true,
    },
    component: () => import('./views/cooperation/joininCooperation'),
  },
  {
    path: '/case',
    name: 'case',
    meta: {
      title: '成功案例',
      keepAlive: true,
    },
    component: () => import('./views/case/case'),
  },
  {
    path: '/caseDetails',
    name: 'caseDetails',
    meta: {
      title: '案例详情',
      iftoTop: true,
    },
    component: () => import('./views/case/caseDetails'),
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    meta: {
      title: '公司介绍',
      iftoTop: true,
    },
    component: () => import('./views/aboutus/aboutus'),
  },
  {
    path: '/news',
    name: 'news',
    meta: {
      title: '新闻报道',
      keepAlive: true,
    },
    component: () => import('./views/news/news'),
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    meta: {
      title: '新闻详情',
      iftoTop: true,
    },
    component: () => import('./views/news/newsDetails'),
  },
  {
    path: '/recruit',
    name: 'recruit',
    meta: {
      title: '招聘',
      keepAlive: true,
    },
    component: () => import('./views/recruit/recruit'),
  },
  {
    path: '/recruitDetails',
    name: 'recruitDetails',
    meta: {
      title: '职位详情',
      iftoTop: true,
    },
    component: () => import('./views/recruit/recruitDetails'),
  },
  {
    path: '/download',
    name: 'download',
    meta: {
      title: '产品下载',
      iftoTop: true,
    },
    component: () => import('./views/download/download'),
  },
  {
    path: '/signup',
    name: 'signup',
    meta: {
      title: '申请试用',
      iftoTop: true,
    },
    component: () => import('./views/signup/signup'),
  },
  {
    path: '/signupSuc',
    name: 'signupSuc',
    meta: {
      title: '申请成功',
      iftoTop: true,
    },
    component: () => import('./views/signup/signupSuc'),
  },
];
// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

router.afterEach((to, from, next) => {
  const toTop = to.meta && to.meta.iftoTop
  if (toTop) {
    window.scrollTo(0, 0)
  }
});
export {
  router,
}
